import { FormValueSelector } from '../../../Common/forms'
import { ProposalBlock } from '@vzmi/shp_shared_compo'
import Editor from '../../Common/ProposalForm/Editor/Editor'
import Warranty from '../../ProductListingBaseForm/Media/Warranty'

const UpdateCopy = props => {
  const {
    readOnly,
    change,
    flags,
    user,
    copy,
    isEditPage
  } = props
  return (
    <>
      <ProposalBlock>
        {/* 商品詳情 */}
        <FormValueSelector
          selector={select => ({
            // 根據 shipType 決定是否顯示廢四機選項
            shipType: select('skuDetail.shipType')
          })}
        >
          {({ shipType }) => {
            return (
              <Editor
                fieldName='copy'
                shipType={shipType}
                readOnly={readOnly}
                copy={copy}
                isEditPage={isEditPage}
              />
            )
          }}
        </FormValueSelector>
      </ProposalBlock>
      <ProposalBlock>
        {/* 商品保證 */}
        <Warranty
          fieldName='warranty'
          triggerFieldChange={change}
          flags={flags}
          user={user}
          isNewProposal={false}
          readOnly={readOnly}
        />
      </ProposalBlock>
    </>
  )
}

export default UpdateCopy
